import { render } from "./layout.md?vue&type=template&id=c9ad480a"
import script from "./layout.md?vue&type=script&lang=js"
export * from "./layout.md?vue&type=script&lang=js"
script.render = render

export default script